<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="订单编号" prop="user">
              <a-input v-model="formInline.orderNo" placeholder="订单编号">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="用户id" prop="password">
              <a-input
                v-model="formInline.userUid"
                type=""
                placeholder="用户id"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="下单时间" prop="slectTime">
              <a-range-picker v-model="slectTime" format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <bargainingOrderContentTwo
          :formInline="formInline"
          ref="aaa"
        ></bargainingOrderContentTwo>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import bargainingOrderContentTwo from "./bargainingOrderContentTwo.vue";
export default {
  components: {
    bargainingOrderContentTwo,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        userUid: null,
        endTime: null,
        createTime: "",
        limit: 10,
        page: 1,
        cutNo: "",
      },
      slectTime:null,
    };
  },
  mounted() {},
  methods: {
    handleSubmit(e) {
      this.$bus.$emit("Order");
      console.log(this.formInline);
      // console.log(this.$refs.bbb)
    },
    handleChange() {},
    getQue(data) {
      console.log(data);
    },
    resetForm() {
      //this.$refs.ruleForm.resetFields();
      this.formInline = {
        orderNo: "",
        userUid: "",
        endTime: "",
        createTime: "",
        limit: 10,
        page: 1,
      };
      this.slectTime = null;
      this.$refs.aaa.getOrderListData();

    },
    seach() {
      this.$refs.aaa.query();
    },
    onChange(date, dateString) {
      console.log(dateString);
      this.formInline.endTime = dateString ? dateString[1] : "";
      this.formInline.createTime = dateString ? dateString[0] : "";
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/bargainingOrderTwo/bargainingOrderHomeTwo.vue